// Fronted/src/contexts/AppContextProvider.js
import { AnnouncementsProvider } from './AnnouncementsContext';
import { CampusProvider } from './CampusContext';
import { CellMinistryProvider } from './CellMinistryContext';
import { ContactProvider } from './ContactContext';
import { EventsProvider } from './EventsContext';
import { LeaderProvider } from './LeaderContext';
import { MinistryProvider } from './MinistryContext';
import { PaymentProvider } from './PaymentContext';
import { UpdatesProvider } from './updatesContext';

const AppContextProvider = ({ children }) => {
  
  return (
     <UpdatesProvider>
      <EventsProvider>
      <LeaderProvider>
      <MinistryProvider>
        <CellMinistryProvider>
          <AnnouncementsProvider>
            <CampusProvider>
              <ContactProvider>
                <PaymentProvider>
                  {children}
                </PaymentProvider>
              </ContactProvider>
            </CampusProvider>
          </AnnouncementsProvider>
        </CellMinistryProvider>
      </MinistryProvider>
      </LeaderProvider>
    </EventsProvider>
     </UpdatesProvider>
      
  );
};

export default AppContextProvider; 